module.exports = __webpack_public_path__ + "fonts/primeicons.c08d00ca.eot";